import React, { useEffect, useState } from "react";
import "./notes.css";
import { generateClient } from 'aws-amplify/api';
import { onSlideChange } from "../../graphql/subscriptions";
const client = generateClient();

// Define props type
interface NotesProps {
  slidesData: {
    type: string;
    sequence: number;
    url?: string;
    fileName?: string;
    id: string;
    notes?: string;
  }[];
  selectedSlideSequence: number;
  eventId: string;
}

const Notes: React.FC<NotesProps> = ({ slidesData, selectedSlideSequence, eventId }) => {
  const [selectedSlide, setSelectedSlide] = useState<NotesProps["slidesData"][number] | null>(null);

  useEffect(() => {
    const foundSlide = slidesData.find((slide) => slide.sequence === selectedSlideSequence);
          setSelectedSlide(foundSlide || null);
  }, [selectedSlideSequence]);
  useEffect(() => {
    const subscription = client.graphql({ query: onSlideChange });
    const observer = subscription.subscribe({
      next: ({ data }) => {
        const newSlide = data?.onSlideChange;

        if (newSlide && newSlide.id === eventId) {
          const foundSlide = slidesData.find((slide) => slide.sequence === newSlide.sequence);
          setSelectedSlide(foundSlide || null);
        }
      },
      error: (error) => console.warn('Subscription error:', error),
    });

    return () => observer.unsubscribe();
  }, [slidesData, eventId]);

  return (
    <div className="notes-container">
      {selectedSlide?.notes ? (
        <p className="notes-text">{selectedSlide.notes}</p>
      ) : (
        <p className="notes-text">Slide Notes</p>
      )}
    </div>
  );
};

export default Notes;
